var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 29.671875 11.894531 L 29.671875 11.890625 C 29.636719 11.71875 29.585938 11.546875 29.546875 11.378906 C 28.515625 10.820312 27.144531 10.339844 25.5625 10 C 23.773438 9.613281 21.714844 9.398438 19.574219 9.398438 C 17.054688 9.398438 14.417969 9.695312 11.949219 10.339844 C 11.792969 10.378906 11.636719 10.425781 11.484375 10.472656 C 11.683594 11.757812 11.945312 13.011719 12.261719 14.222656 C 12.78125 14.039062 13.3125 13.886719 13.859375 13.765625 C 14.605469 13.605469 15.351562 13.53125 16.085938 13.53125 C 18.492188 13.535156 20.765625 14.316406 22.8125 15.347656 C 24.859375 16.382812 26.695312 17.679688 28.226562 18.761719 C 28.605469 19.03125 28.960938 19.28125 29.300781 19.515625 C 29.75 18.089844 30 16.574219 30 15 C 30 13.933594 29.886719 12.894531 29.671875 11.894531 Z M 29.671875 11.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.507812 8.664062 L 11.511719 8.664062 C 14.144531 7.976562 16.921875 7.667969 19.574219 7.667969 C 21.832031 7.667969 24 7.890625 25.925781 8.308594 C 26.964844 8.53125 27.929688 8.8125 28.804688 9.144531 C 27.09375 5.113281 23.667969 1.976562 19.441406 0.671875 C 19.195312 0.855469 18.945312 1.066406 18.679688 1.3125 C 18.074219 1.867188 17.417969 2.550781 16.652344 3.265625 C 15.292969 4.535156 13.5625 5.886719 11.148438 6.675781 C 11.152344 7.371094 11.167969 8.0625 11.246094 8.738281 C 11.332031 8.714844 11.417969 8.6875 11.507812 8.664062 Z M 11.507812 8.664062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 17.347656 0.1875 C 16.585938 0.0664062 15.800781 0 15 0 C 13.996094 0 13.023438 0.105469 12.078125 0.292969 C 11.941406 0.789062 11.785156 1.40625 11.636719 2.09375 C 11.453125 2.945312 11.289062 3.894531 11.210938 4.820312 C 12.441406 4.339844 13.449219 3.695312 14.339844 2.984375 C 15.476562 2.078125 16.410156 1.070312 17.347656 0.1875 Z M 17.347656 0.1875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 9.445312 5.320312 C 9.507812 4.074219 9.710938 2.820312 9.945312 1.730469 C 10.015625 1.40625 10.085938 1.097656 10.15625 0.808594 C 7.992188 1.542969 6.050781 2.761719 4.453125 4.339844 C 5.542969 5.027344 6.828125 5.410156 8.257812 5.414062 C 8.644531 5.414062 9.042969 5.378906 9.445312 5.320312 Z M 9.445312 5.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.523438 12.367188 C 5.382812 11.039062 7.480469 9.980469 9.5625 9.253906 C 9.550781 9.148438 9.535156 9.042969 9.523438 8.9375 C 9.453125 8.296875 9.433594 7.675781 9.425781 7.066406 C 9.03125 7.113281 8.640625 7.144531 8.257812 7.144531 C 6.410156 7.144531 4.695312 6.609375 3.277344 5.644531 C 1.226562 8.210938 0 11.453125 0 15 C 0 15.203125 0.0078125 15.40625 0.0117188 15.605469 C 1 14.398438 2.203125 13.3125 3.523438 12.367188 Z M 3.523438 12.367188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 10.675781 14.980469 C 10.328125 13.699219 10.035156 12.375 9.8125 11.007812 C 7.988281 11.671875 6.148438 12.617188 4.53125 13.773438 C 2.777344 15.03125 1.292969 16.53125 0.335938 18.152344 C 0.910156 20.824219 2.191406 23.234375 3.980469 25.175781 C 3.992188 25.144531 4 25.117188 4.011719 25.082031 C 4.226562 24.417969 4.476562 23.640625 4.785156 22.808594 C 5.402344 21.148438 6.265625 19.265625 7.667969 17.578125 C 8.472656 16.613281 9.46875 15.722656 10.675781 14.980469 Z M 10.675781 14.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.902344 24.59375 C 13.398438 22.316406 12.132812 19.648438 11.179688 16.703125 C 9.753906 17.675781 8.710938 18.902344 7.914062 20.214844 C 6.953125 21.792969 6.355469 23.484375 5.882812 24.921875 C 5.695312 25.492188 5.53125 26.015625 5.363281 26.492188 C 7.972656 28.679688 11.324219 30 15 30 C 16.433594 30 17.820312 29.796875 19.136719 29.417969 C 17.582031 28.125 16.160156 26.492188 14.902344 24.59375 Z M 14.902344 24.59375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 23.882812 17.929688 C 21.480469 16.460938 18.78125 15.257812 16.085938 15.261719 C 15.46875 15.261719 14.847656 15.324219 14.226562 15.460938 C 13.707031 15.570312 13.21875 15.722656 12.742188 15.898438 C 13.660156 18.8125 14.890625 21.4375 16.347656 23.636719 C 17.746094 25.753906 19.347656 27.480469 21.050781 28.71875 C 24.015625 27.410156 26.476562 25.175781 28.0625 22.375 C 28.28125 21.988281 28.476562 21.585938 28.664062 21.179688 C 28.210938 20.871094 27.734375 20.53125 27.226562 20.175781 C 26.210938 19.453125 25.085938 18.664062 23.882812 17.929688 Z M 23.882812 17.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.453125 27.894531 L 3.519531 27.953125 L 3.457031 27.898438 C 3.457031 27.894531 3.453125 27.894531 3.453125 27.894531 Z M 3.453125 27.894531 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.3d086a452eb19169837de4771408b6d6.svg";
export { ForwardRef as ReactComponent };